import React from 'react';
import BadgeIcon from './BadgeIcon';
import { BadgeType, BadgeTier, getBadgeDisplayName, getTierDisplayName } from '../utils/badges';

interface BadgeDisplayProps {
  type: BadgeType;
  tier: BadgeTier;
  animate?: boolean;
  showLabel?: boolean;
}

const BadgeDisplay: React.FC<BadgeDisplayProps> = ({ type, tier, animate = false, showLabel = true }) => {
  const badgeName = getBadgeDisplayName(type, tier);
  const tierName = getTierDisplayName(tier);

  return (
    <div className="badge-display">
      <BadgeIcon type={type} tier={tier} size="xlarge" animate={animate} />
      {showLabel && badgeName && (
        <div className="badge-label">
          <div className="badge-name">{badgeName}</div>
          {tierName && (
            <div className={`badge-tier ${tier}`}>{tierName}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default BadgeDisplay;
